import {
  createCollection as publicCreateCollection,
  getCollection as publicGetCollection,
  listCollections as publicListCollections,
  updateCollection as publicUpdateCollection,
  deleteCollection as publicDeleteCollection,
  queryCollections as publicQueryCollections,
  typedQueryCollections as publicTypedQueryCollections,
} from './portfolio-collections-v1-collection-collections.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  CollectionQuery,
  CollectionsQueryBuilder,
  QueryCollectionsOptions,
  typedQueryCollections as universalTypedQueryCollections,
} from './portfolio-collections-v1-collection-collections.universal.js';
import { onCollectionCreated as publicOnCollectionCreated } from './portfolio-collections-v1-collection-collections.public.js';
import { onCollectionDeleted as publicOnCollectionDeleted } from './portfolio-collections-v1-collection-collections.public.js';
import { onCollectionUpdated as publicOnCollectionUpdated } from './portfolio-collections-v1-collection-collections.public.js';

function customQueryCollections(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryCollectionsOptions) =>
      publicQueryCollections(httpClient)(options),
    typedQueryFunction: (
      query: CollectionQuery,
      options?: QueryCollectionsOptions
    ) => publicTypedQueryCollections(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: CollectionQuery,
    options?: QueryCollectionsOptions
  ): ReturnType<typeof universalTypedQueryCollections>;
  function overloadedQuery(
    options?: QueryCollectionsOptions
  ): CollectionsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: CollectionQuery | QueryCollectionsOptions,
    options?: QueryCollectionsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createCollection: MaybeContext<
  BuildRESTFunction<typeof publicCreateCollection> &
    typeof publicCreateCollection
> = /*#__PURE__*/ createRESTModule(publicCreateCollection);
export const getCollection: MaybeContext<
  BuildRESTFunction<typeof publicGetCollection> & typeof publicGetCollection
> = /*#__PURE__*/ createRESTModule(publicGetCollection);
export const listCollections: MaybeContext<
  BuildRESTFunction<typeof publicListCollections> & typeof publicListCollections
> = /*#__PURE__*/ createRESTModule(publicListCollections);
export const updateCollection: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCollection> &
    typeof publicUpdateCollection
> = /*#__PURE__*/ createRESTModule(publicUpdateCollection);
export const deleteCollection: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCollection> &
    typeof publicDeleteCollection
> = /*#__PURE__*/ createRESTModule(publicDeleteCollection);
export const queryCollections: MaybeContext<
  BuildRESTFunction<typeof customQueryCollections> &
    typeof customQueryCollections
> = /*#__PURE__*/ createRESTModule(customQueryCollections);
/**
 * Triggered when a collection is created.
 */
export const onCollectionCreated: BuildEventDefinition<
  typeof publicOnCollectionCreated
> &
  typeof publicOnCollectionCreated = createEventModule(
  publicOnCollectionCreated
);
/**
 * Triggered when a collection is deleted.
 */
export const onCollectionDeleted: BuildEventDefinition<
  typeof publicOnCollectionDeleted
> &
  typeof publicOnCollectionDeleted = createEventModule(
  publicOnCollectionDeleted
);
/**
 * Triggered when a collection is updated.
 */
export const onCollectionUpdated: BuildEventDefinition<
  typeof publicOnCollectionUpdated
> &
  typeof publicOnCollectionUpdated = createEventModule(
  publicOnCollectionUpdated
);

export {
  ImageType,
  WebhookIdentityType,
  SortOrder,
} from './portfolio-collections-v1-collection-collections.universal.js';
export {
  Collection,
  Image,
  Point,
  UnsharpMasking,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  AdminRemoveMenuItemsResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateCollectionRequest,
  CreateCollectionResponse,
  GetCollectionRequest,
  GetCollectionResponse,
  ListCollectionsRequest,
  CursorPaging,
  ListCollectionsResponse,
  PagingMetadataV2,
  Cursors,
  UpdateCollectionRequest,
  UpdateCollectionResponse,
  DeleteCollectionRequest,
  DeleteCollectionResponse,
  QueryCollectionsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  QueryCollectionsResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  CollectionCreatedEnvelope,
  CollectionDeletedEnvelope,
  CollectionUpdatedEnvelope,
  GetCollectionOptions,
  ListCollectionsOptions,
  UpdateCollection,
  QueryCollectionsOptions,
  CollectionsQueryResult,
  CollectionsQueryBuilder,
  CollectionQuerySpec,
} from './portfolio-collections-v1-collection-collections.universal.js';
export { utils } from './portfolio-collections-v1-collection-collections.universal.js';
export {
  ImageTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
  SortOrderWithLiterals,
  CommonQueryWithEntityContext,
  CollectionQuery,
} from './portfolio-collections-v1-collection-collections.universal.js';
